import { ContentClassificationView } from '../../../../api/client'
import { getModerationStyles } from '../../../../util/moderationStyles'
import ClassificationDisplay from '../ClassificationDisplay'
import { ContentMetadataRow, SectionHeader } from './ContentMetadataModal'

type Props = {
    moderation: string | null | undefined
    severeClassifications: ContentClassificationView[]
    suspectClassifications: ContentClassificationView[]
    accountId: number
    contentId: number
}

/**
 * Displays moderation status and contributing classifications in the metadata modal.
 * Uses the same styled badges as the content card.
 */
export default function ContentMetadataClassification(props: Props) {
    const { moderation, severeClassifications, suspectClassifications, accountId, contentId } =
        props

    const hasClassifications =
        severeClassifications.length > 0 || suspectClassifications.length > 0

    const styles = getModerationStyles(moderation)
    const moderationStyle = `${styles.text} ${styles.background} ${styles.border}`
    const moderationDisplay = moderation ? moderation.charAt(0) + moderation.slice(1).toLowerCase() : 'Not set'

    return (
        <div>
            <SectionHeader title="Moderation" />
            <div className="mt-3 border-t border-gray-100">
                <dl className="divide-y divide-gray-100">
                    <ContentMetadataRow title="Status:" zebra_dark={true}>
                        <span
                            className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${moderationStyle}`}
                        >
                            {moderationDisplay}
                        </span>
                    </ContentMetadataRow>

                    {hasClassifications && (
                        <ContentMetadataRow title="Classifications:" zebra_dark={false}>
                            <div className="flex flex-row flex-wrap items-center gap-2">
                                {severeClassifications.map((classification) => (
                                    <ClassificationDisplay
                                        key={`${classification.classifierName}_${classification.classification}_severe`}
                                        queue="SEVERE"
                                        classification={classification}
                                        accountId={accountId}
                                        contentId={contentId}
                                    />
                                ))}
                                {suspectClassifications.map((classification) => (
                                    <ClassificationDisplay
                                        key={`${classification.classifierName}_${classification.classification}_suspect`}
                                        queue="SUSPECT"
                                        classification={classification}
                                        accountId={accountId}
                                        contentId={contentId}
                                    />
                                ))}
                            </div>
                        </ContentMetadataRow>
                    )}

                    {!hasClassifications && (
                        <ContentMetadataRow title="Classifications:" zebra_dark={false}>
                            <span className="text-gray-500">None</span>
                        </ContentMetadataRow>
                    )}
                </dl>
            </div>
        </div>
    )
}
